import React from 'react';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
export function OnboardingForm() {
  return <div className="flex-1 flex flex-col h-full relative" data-id="element-35">
      <div className="px-8 pb-24 overflow-y-auto flex-1" data-id="element-36">
        <h1 className="text-3xl font-semibold mb-3" data-id="element-37">Tell us more about you</h1>
        <p className="text-gray-600 mb-6" data-id="element-38">
          We just need a few more details to complete your profile.
        </p>
        <div className="space-y-4" data-id="element-39">
          <div data-id="element-40">
            <label htmlFor="role" className="block text-sm font-medium mb-1" data-id="element-41">
              What is your role?
            </label>
            <div className="relative" data-id="element-42">
              <select id="role" className="appearance-none block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue="" data-id="element-43">
                <option value="" disabled data-id="element-44">
                  Select an option
                </option>
                <option value="developer" data-id="element-45">Developer</option>
                <option value="designer" data-id="element-46">Designer</option>
                <option value="product_manager" data-id="element-47">Product Manager</option>
                <option value="marketing" data-id="element-48">Marketing</option>
                <option value="other" data-id="element-49">Other</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-50">
                <ChevronDownIcon className="h-5 w-5 text-gray-400" data-id="element-51" />
              </div>
            </div>
          </div>
          <div data-id="element-52">
            <label htmlFor="use-case" className="block text-sm font-medium mb-1" data-id="element-53">
              What is your main use-case with Lindy?
            </label>
            <div className="relative" data-id="element-54">
              <select id="use-case" className="appearance-none block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue="" data-id="element-55">
                <option value="" disabled data-id="element-56">
                  Select an option
                </option>
                <option value="email_automation" data-id="element-57">Email Automation</option>
                <option value="workflow_management" data-id="element-58">Workflow Management</option>
                <option value="analytics" data-id="element-59">Analytics</option>
                <option value="collaboration" data-id="element-60">Team Collaboration</option>
                <option value="other" data-id="element-61">Other</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-62">
                <ChevronDownIcon className="h-5 w-5 text-gray-400" data-id="element-63" />
              </div>
            </div>
          </div>
          <div data-id="element-64">
            <label htmlFor="referral" className="block text-sm font-medium mb-1" data-id="element-65">
              How did you hear about us?
            </label>
            <div className="relative" data-id="element-66">
              <select id="referral" className="appearance-none block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" defaultValue="" data-id="element-67">
                <option value="" disabled data-id="element-68">
                  Select an option
                </option>
                <option value="search" data-id="element-69">Search Engine</option>
                <option value="social" data-id="element-70">Social Media</option>
                <option value="friend" data-id="element-71">Friend or Colleague</option>
                <option value="blog" data-id="element-72">Blog or Article</option>
                <option value="other" data-id="element-73">Other</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-74">
                <ChevronDownIcon className="h-5 w-5 text-gray-400" data-id="element-75" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-white p-4 border-t border-gray-100 flex items-center justify-between" data-id="element-76">
        <div className="flex space-x-1" data-id="element-77">
          <div className="w-8 h-2 bg-blue-500 rounded-full" data-id="element-78"></div>
          <div className="w-2 h-2 bg-gray-300 rounded-full" data-id="element-79"></div>
          <div className="w-2 h-2 bg-gray-300 rounded-full" data-id="element-80"></div>
        </div>
        <button type="button" className="inline-flex items-center px-6 py-2 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-81">
          Continue
          <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-82" />
        </button>
      </div>
    </div>;
}